import { PixelUnit } from '@starrez/starryui/dist/Theme';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { ICurrentFilter } from '../../../../.starryUI/filters/filterBar';
import { DisplayFilterButton } from '../../../../.starryUI/filters/filterBar/components/DisplayFilterButton';
import { useLazyAllEntryStatus } from '../graphql/useLazyAllEntryStatusQuery';

export interface IFixedFilters {
    filters: string[]; // Please note that this field will be moved to directory workspace with approperiate type
}
export const FixedFilters = ({ filters }: IFixedFilters) => {
    const getEntryStatus = useLazyAllEntryStatus();
    const [fixedFilters, setFixedFilters] = useState<ICurrentFilter[]>([]);

    //Please note that this logic is temporary to help display the fixed filter string.
    useEffect(() => {
        if (filters) {
            setFixedFilters([]);
            filters.forEach((f) => {
                const filter: { ids: string[]; key: string } = JSON.parse(f);
                if (filter.key === 'entryStatus') {
                    getEntryStatus({}).then(({ data }) => {
                        setFixedFilters((fixedFilters) => [
                            ...fixedFilters,
                            {
                                name: 'Entry Status',
                                value: data?.allEntryStatus
                                    .filter((e) => filter.ids.includes(e.enumValue))
                                    .map((e) => ({ caption: e.description, value: e.enumValue })),
                            },
                        ]);
                    });
                }
            });
        }
    }, [filters, getEntryStatus, setFixedFilters]);

    return (
        <FixedFiltersWrapper>
            {fixedFilters.map(
                (f) =>
                    f.value && (
                        <DisplayFilterButton key={f.name} active={false} caption={f.name} dropdownVisible={false} removable={false} value={f.value} />
                    )
            )}
        </FixedFiltersWrapper>
    );
};

const FixedFiltersWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    height: 40px;
    > div {
        margin: 0 ${PixelUnit(1)} ${PixelUnit(1)} 0;
    }
`;
